const AppleIcon = (props: { className: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M10.8294 1C10.9213 1.71014 10.5876 2.42319 10.0921 2.93647C9.59997 3.44975 8.78944 3.84784 7.99424 3.79534C7.88526 3.09833 8.28372 2.37361 8.74517 1.91866C9.2526 1.40829 10.1159 1.02333 10.8294 1Z"
      fill="white"
    />
    <path
      d="M13.6155 5.67597C13.6155 5.67597 13.6117 5.67822 13.6088 5.67994C13.4781 5.75663 12.0054 6.62088 12.021 8.37127C12.0436 10.4693 13.9031 11.1936 13.9965 11.23C13.9984 11.2308 14 11.2314 14 11.2314L13.9988 11.2351C13.9732 11.3178 13.6788 12.2675 12.983 13.2435C12.3682 14.1034 11.7287 14.96 10.7259 14.982C10.2455 14.9903 9.92356 14.8564 9.58889 14.7171C9.23724 14.5708 8.87155 14.4187 8.29329 14.4195C7.6895 14.4195 7.30884 14.5757 6.94213 14.7261C6.6234 14.8568 6.31521 14.9832 5.88021 14.999C4.90931 15.0347 4.17227 14.0695 3.55217 13.2095C2.28539 11.4574 1.31803 8.25571 2.61493 6.08554C3.25984 5.0115 4.41323 4.33003 5.66406 4.31303C6.20641 4.30242 6.7299 4.50174 7.18748 4.67596C7.53559 4.80851 7.84555 4.92653 8.09663 4.92653C8.32249 4.92653 8.62568 4.81204 8.97949 4.67844C9.53603 4.46829 10.2178 4.21085 10.9208 4.27734C11.4009 4.29604 12.7474 4.46428 13.6155 5.67597Z"
      fill="white"
    />
  </svg>
);

const AndroidIcon = (props: { className: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.10579 4.44719C1.8588 3.95321 2.05903 3.35254 2.55301 3.10555C3.04698 2.85856 3.64766 3.05878 3.89465 3.55276L4.92453 5.61252C5.87133 5.2179 6.91022 5 8 5C9.08992 5 10.1289 5.21796 11.0758 5.61267L12.1058 3.55276C12.3528 3.05878 12.9535 2.85856 13.4474 3.10555C13.9414 3.35254 14.1416 3.95321 13.8946 4.44719L12.8135 6.60955C14.7489 8.06969 16 10.3887 16 13H0C0 10.3886 1.25122 8.06944 3.18685 6.60931L2.10579 4.44719ZM4.5 11C5.05228 11 5.5 10.5523 5.5 10C5.5 9.44772 5.05228 9 4.5 9C3.94772 9 3.5 9.44772 3.5 10C3.5 10.5523 3.94772 11 4.5 11ZM12.5 10C12.5 10.5523 12.0523 11 11.5 11C10.9477 11 10.5 10.5523 10.5 10C10.5 9.44772 10.9477 9 11.5 9C12.0523 9 12.5 9.44772 12.5 10Z"
      fill="white"
    />
  </svg>
);

export { AppleIcon, AndroidIcon };
